import { render, staticRenderFns } from "./addStaffView.vue?vue&type=template&id=3c9e48d6&scoped=true"
import script from "./addStaffView.vue?vue&type=script&lang=js"
export * from "./addStaffView.vue?vue&type=script&lang=js"
import style0 from "./addStaffView.vue?vue&type=style&index=0&id=3c9e48d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9e48d6",
  null
  
)

export default component.exports